// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2y3fj","name":"ConsentHeader_name__3EzMK","birthday":"ConsentHeader_birthday__1cogJ","skeleton":"ConsentHeader_skeleton__3MMMY"};